<template>
  <el-tree
    v-loading="loading"
    class="project-resource-tree"
    ref="tree"
    :data="tree"
    node-key="id"
    check-strictly
    show-checkbox
    default-expand-all
    v-bind="$attrs"
    v-on="$listeners"
    :props="{
      label: labelHandler,
      disabled: disableHandler
    }"
    ><template #default="{ data, node }"
      ><render-vnode :vnode="getTreeItem(data, node)"></render-vnode></template
  ></el-tree>
</template>
<script>
import {
  arrayEquals,
  deepTreeData,
  getIdsData,
  getMenuIcons,
  isInactive
} from '../plugins/utils.js'
export default {
  name: 'project-resource-tree',
  props: {
    projectid: String,
    disableHandler: [String, Function]
  },
  data() {
    console.log('this.$root.environment', this.$root.environment)
    return {
      loading: false,
      tree: [],
      treeIds: [],
      allResourceData: []
    }
  },
  methods: {
    labelHandler(data, node) {
      return data.name || data.rel_name
    },
    getTreeItem(data, node) {
      var inactive = isInactive(data, this.$root.environment)
      var icons = this.getIcon(data)
      return (
        <span
          class={inactive ? 'inactive-node' : ''}
          title={inactive ? '该资源在当前环境已禁用' : ''}
        >
          {icons}
          <span>{this.labelHandler(data, node)}</span>
        </span>
      )
    },
    getIcon(data) {
      var icons = getMenuIcons(data)
      if (icons.length > 0) {
        return (
          <span style='margin-right: 2px'>
            {icons.map((icon) => (
              <i class={icon} style='margin-right: 2px'></i>
            ))}
          </span>
        )
      }
      return null
    },
    isInactive(data) {
      if (!data.active_envs) {
        return false
      }
      return data.active_envs.includes(this.$root.environment + '1')
        ? false
        : true
    },
    setCheckedKeys(keys) {
      if (this.$refs.tree) {
        this.$refs.tree.setCheckedKeys(keys)
      }
    },
    getCheckedKeys() {
      if (this.$refs.tree) {
        return this.$refs.tree.getCheckedKeys()
      }
      return []
    },
    refreshProjectResource() {
      clearTimeout(window.refreshProjectResourceTimeout)
      window.refreshProjectResourceTimeout = setTimeout(() => {
        this.getProjectResource()
      }, 100)
    },
    getProjectResource() {
      this.loading = true
      this.$post('/resource/findRelView', {
        PageIndex: 1,
        PageSize: 9999,
        project: JSON.stringify({
          Field: 'a.project',
          ComparePattern: 1,
          Values: [this.projectid]
        }),
        SortFields: JSON.stringify([
          {
            Field: 'a.sort_order',
            Order: 1
          }
        ])
      })
        .then((resp) => {
          this.loading = false
          if (resp.data.code == 0) {
            this.allResourceData = resp.data.data.Data
            this.treeIds = getIdsData(resp.data.data.Data, 'id')
            this.tree = deepTreeData(resp.data.data.Data, '0')
            this.$emit('tree-loaded', this.tree)
            // this.getRoleRes()
          } else {
            this.$message(`获取项目资源失败:${resp.data.msg}`)
          }
        })
        .catch((err) => {
          this.loading = false
          console.error('获取项目资源发生异常=>', err)
          this.$message(`获取项目资源发生异常:${err}`)
        })
    }
  },
  watch: {
    projectid: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.refreshProjectResource()
        }
      }
    }
  }
}
</script>
<style lang="less">
.project-resource-tree {
  .inactive-node {
    color: #f56c6c;
    text-decoration: line-through;
  }
}
</style>
